module.exports = __webpack_public_path__ + "img/mb_thumb.3d4ee858.gif";